/* unplugin-vue-components disabled */import { render } from "./AppShowcasePopup.vue?vue&type=template&id=05881b34"
import script from "./AppShowcasePopup.vue?vue&type=script&lang=js"
export * from "./AppShowcasePopup.vue?vue&type=script&lang=js"

import "./AppShowcasePopup.vue?vue&type=style&index=0&id=05881b34&lang=scss"
script.render = render

export default script